// Campus photo for /colleges/santa-clara-university: CC BY-SA 4.0, by Eugene Zelenko, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUSA-Santa_Clara-Mission-1.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/santa-clara-university/; credited under the photo.
const photo = {
    "slug": "santa-clara-university",
    "alt": "Mission Santa Clara de Asis, the mission church at the center of the Santa Clara University campus in Santa Clara, California",
    "src": "/colleges/santa-clara-university/campus-1600.webp",
    "srcSmall": "/colleges/santa-clara-university/campus-800.webp",
    "srcMid": "/colleges/santa-clara-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/santa-clara-university/og.jpg",
    "title": "USA-Santa Clara-Mission-1",
    "author": "Eugene Zelenko",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUSA-Santa_Clara-Mission-1.jpg",
    "read": "2026-10-01"
};

export default photo;
